<template>
  <div class="app-container">
    <el-form ref="RefForm" :model="form" :rules="rules" label-width="120px">
      <BjDivider
        >手动刷新服务权限
        <template slot="button">
          <el-button @click="onUpdateIAM">刷新</el-button>
        </template>
      </BjDivider>
      <el-row>
        <el-col :span="8">
          <el-form-item label="服务名" prop="instanceId">
            <BjSelectInstancesService
              v-model="form.instanceId"
              code="HADM.INSTANCE"
              @change="onChangeServiceName"
            />
          </el-form-item>
          <el-form-item label="">
            <template slot="label"
              >服务标记版本
              <el-tooltip effect="dark" placement="top-start" content="不输入版本是刷新最新版本">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <BjInput v-model="form.metaVersion" />
          </el-form-item>
          <el-form-item label="清除过期权限">
            <el-switch v-model="form.cleanPermission"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { baseDataApi } from '@/api';
export default {
  data() {
    return {
      form: {
        instanceId: null,
        serviceName: null,
        metaVersion: null,
        cleanPermission: true,
      },
      rules: {
        instanceId: [{ required: true, message: '请选择服务名', trigger: 'change' }],
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    /** 刷新IAM */
    onUpdateIAM() {
      this.$confirm('确认刷新服务权限', this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.$refs.RefForm.validate((valid) => {
            if (valid) {
              const { serviceName, metaVersion, cleanPermission } = this.form;
              this.updateApi('updateToolPermissionFresh', {
                serviceName,
                metaVersion,
                cleanPermission,
              });
            }
          });
        })
        .catch(() => {});
    },
    onChangeServiceName(v, item) {
      this.form.serviceName = item.service;
      this.form.metaVersion = item.version;
    },
    updateApi(API, DATA) {
      baseDataApi[API](DATA);
    },
  },
};
</script>
